import { InvestmentGoalsRiskLevel } from '../../../../types';
export var list = [
    InvestmentGoalsRiskLevel.LOW,
    InvestmentGoalsRiskLevel.MEDIUM,
    InvestmentGoalsRiskLevel.HIGH,
];
